module.exports = __webpack_public_path__ + "img/web-dev-design.447255e1.svg";